<template>
  <div class="tags-wrapper">
    <tag-manager resourceType="folder" :resource='folder' @reload-list="success" />

    <div class="tag-dropdown-column">
      <div class="existing-tags-wrapper" :class="tag.color" v-for="tag in folder.tags">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn active">
            <router-link :to="{name: 'tag', params: { id: tag.id }}">
              {{tag.name}}
            </router-link>
          </label>

          <label class="btn" @click.prevent="removeConnectedTag(tag, folder.id)">
            <i class="fa fa-remove"></i>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _tag_manager from "./_tags_manager"

  export default {
    components: {
      'tag-manager': _tag_manager
    },
    props: ['folder'],
    methods: {
      success() {
        this.$emit('success')
      },
      removeConnectedTag(tag, folderId) {
        this.store.removeConnectedTag(tag.id, { folder_id: folderId }).then(() => {
          this.store.sendMetrics({name: 'remove_tag_from_folder', params: this.$route.params, path: this.$route.fullPath})
          this.success()
        })
      },
    }
  }
</script>
